import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { map, tap } from 'rxjs/operators';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { FormatUtils } from '../../shared/_utils/services/formatUtils';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Bank } from '../entities/bank';
import { FundingMain } from '../entities/funding-main';

@Injectable()
export class FundingMainService extends BaseCrudService<FundingMain> {

    public uri = '/api/fundingMain/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance BankService');
    }

    buildSentence(entity?: FundingMain, event?: LazyLoadEvent): HttpParams {

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

    // getSequenceCode(): Observable<string> {
    //     const url = this.rutaServidor + this.uri + 'maxCode/';
    //     return this.httpClient.get<any>(url)
    //         .pipe(
    //             map(response => {
    //                 // debugger;
    //                 const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 3);
    //                 const sequence = (parseInt(code, 10)) + 1;
    //                 return FormatUtils.padLeftZero(sequence, 3);
    //             }),
    //             tap(response => {
    //                //console.log(response);
    //             })
    //         );
    // }
}



// WEBPACK FOOTER //
// ./src/app/core/services/funding-main.service.ts